/**
 * Draw Templates Configuration
 * Centralized configuration for all available draw templates
 */

export const DRAW_TEMPLATES = {
  single_elimination: {
    name: 'Single Elimination',
    description: 'Standard knockout tournament',
    drawType: 'single_elimination' as const,
    defaultOptions: {
      hasThirdFourthPlayoff: true,
    },
  },
  round_robin: {
    name: 'Round Robin',
    description: 'Everyone plays everyone',
    drawType: 'round_robin' as const,
    defaultOptions: {
      roundRobinSettings: {
        scoringSystem: 'standard' as const,
        tiebreakerOrder: ['games_ratio', 'points_ratio'] as ('games_ratio' | 'points_ratio')[],
      },
    },
  },
  qualifying_single: {
    name: 'Single Elimination with Qualifying',
    description: 'Main draw with qualifying pools (single elimination)',
    drawType: 'single_elimination' as const,
    defaultOptions: {
      hasThirdFourthPlayoff: true,
      seededPlayersCount: 0,
      qualifyingPools: {
        numPools: 8,
        playersPerPool: 1,
        advancementPerPool: 1,
        poolDrawType: 'elimination' as const,
      },
    },
  },
  qualifying_round_robin: {
    name: 'Single Elimination with Qualifying (Round Robin)',
    description: 'Main draw with qualifying pools (round robin)',
    drawType: 'single_elimination' as const,
    defaultOptions: {
      hasThirdFourthPlayoff: true,
      seededPlayersCount: 0,
      qualifyingPools: {
        numPools: 8,
        playersPerPool: 1,
        advancementPerPool: 1,
        poolDrawType: 'round_robin' as const,
        roundRobinAdvancement: {
          scoringSystem: 'standard' as const,
          tiebreakerOrder: ['games_ratio', 'points_ratio'] as ('games_ratio' | 'points_ratio')[],
          seedingStrategy: 'sequential' as const,
        },
      },
    },
  },
  monrad: {
    name: 'Monrad',
    description: 'Main draw with playoff brackets to determine every position',
    drawType: 'monrad' as const,
    defaultOptions: {},
  },
} as const;

export type DrawTemplateKey = keyof typeof DRAW_TEMPLATES;
// DrawType moved to shared types.ts - use import from there
